/* eslint complexity: ["error", { max: 7 }] -- this component does have high configurability/complexity */
import { ExploreTestID, TextTestID } from "@/constants/TestID";
import { IllustrationSize } from "@/constants/UI";
import {
  PreTreatmentDetailsActionBar,
  SensitiveDetailsActionBar,
} from "@/ui/components/groupClasses/series/details/ActionBars";
import EventDetailsAttendeeList from "@/ui/components/schedule/details/EventDetailsAttendeeList";
import EventDetailsLines from "@/ui/components/schedule/details/EventDetailsLines";
import EditEventButton from "@/ui/components/schedule/EditEventButton";
import { Text } from "@/ui/core";
import TextTag from "@/ui/core/TextTag";
import { Box, VStack } from "@/ui/layout";
import { getIllustrationIcon } from "@/ui/theme/icons/illustrations/groupClasses";
import { shouldHideRegistrationStatus } from "@/utils/groupClass.util";
import { joinTestIDs } from "@/utils/string.util";

const GroupClassSeriesDetails = ({
  attendees,
  dateRange,
  description,
  externalId,
  iconName,
  isAppUserSupport,
  isRecurring,
  isSensitive,
  isUserPreTreatment,
  isUserRegistered,
  nextStartDate,
  onEditEventPress,
  recurrenceString,
  timeRange,
  title,
}: GroupClassSeriesDetailsProps) => {
  const baseTestID = ExploreTestID.GroupClassSeriesDetails;
  const shouldShowRegistrationStatus = !shouldHideRegistrationStatus({
    isAppUserSupport,
    isSensitive,
  });
  const isEditable = isUserRegistered && shouldShowRegistrationStatus;
  return (
    <VStack paddingTop={24}>
      <VStack gap={18}>
        <Box testID={joinTestIDs(baseTestID, ExploreTestID.Illustration)}>
          {iconName &&
            getIllustrationIcon({
              height: IllustrationSize.Modal,
              iconName,
              width: IllustrationSize.Modal,
            })}
        </Box>
        <VStack gap={12}>
          <Text testID={joinTestIDs(baseTestID, TextTestID.Title)} variant="h4">
            {title}
          </Text>
          {isEditable && <TextTag text="Registered" />}
        </VStack>
        <EventDetailsLines
          dateRange={dateRange}
          isRecurring={isRecurring}
          nextStartDate={nextStartDate}
          recurrenceString={recurrenceString}
          testID={baseTestID}
          timeRange={timeRange}
        />
        <SensitiveDetailsActionBar
          isAppUserSupport={isAppUserSupport}
          isSensitive={isSensitive}
        />
        {isUserPreTreatment && <PreTreatmentDetailsActionBar />}
      </VStack>
      {isEditable && !isUserPreTreatment && (
        <EditEventButton
          eventId={externalId}
          isGroupClassEvent
          isRecurring={isRecurring}
          onPress={onEditEventPress}
        />
      )}
      <EventDetailsAttendeeList attendees={attendees} isGroupClassEvent />
      <Text
        testID={joinTestIDs(baseTestID, TextTestID.Description)}
        variant="body"
      >
        {description}
      </Text>
    </VStack>
  );
};

export default GroupClassSeriesDetails;
